import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  	providedIn: 'root'
})

export class LanguageService {

	private langSubject = new BehaviorSubject<string>(localStorage.getItem('language') || 'es');
	public lang$ = this.langSubject.asObservable();

	constructor(private translate: TranslateService) {
		this.translate.use(this.langSubject.value);
	}

	public changeLang(lang: string): void {
		this.translate.use(lang);
		localStorage.setItem('language', lang);
		this.langSubject.next(lang);
	}

	public getCurrentLang(): string {
		return this.langSubject.value;
	}

}
